var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bar",class:_vm.classes,style:(_vm.styles)},[_c('div',{staticClass:"value",style:({width:_vm.value/_vm.maxValue*100+'%'})})])}
var staticRenderFns = []

export { render, staticRenderFns }